import React from 'react'

const EtDeleteCoachUserPad = () => {
  return (
    <div>EtDeleteCoachUserPad</div>
  )
}

export default EtDeleteCoachUserPad